import {combineReducers, createStore} from "redux";
import * as actions from './actions';
import * as cnst from './constants';
import {numWeeks} from "./constants";



function dummy(state: string = 'dummy', action) {
    if (action.type == actions.DUMMY) {
        return action.dummy;
    } else {
        return state;
    }
}

function metric(state: string = cnst.metrics[0], action: actions.iChangeMetric){
    if (action.type == actions.ACTION_CHANGE_METRIC){
        return action.metric;
    } else {
        return state;
    }
}

function the_time(state: string = cnst.times[0], action: actions.iChangeTime){
    if (action.type == actions.ACTION_CHANGE_TIME){
        return action.time;
    } else {
        return state;
    }
}

function week(state: number = cnst.numWeeks - 1, action: actions.iChangeWeek){
    if (action.type == actions.ACTION_CHANGE_WEEK){
        if (action.week < 0){
            return 0;
        } else if (action.week > cnst.numWeeks){
            return numWeeks;
        } else {
            return action.week;
        }
        // return action.week;
    } else {
        return state;
    }
}

function legend(state: object[] = [], action: actions.iChangeLegend) {
    if (action.type === actions.ACTION_CHANGE_LEGEND){
        return action.legend;
    } else {
        return state
    }

}

export const store = createStore(
    combineReducers({metric, the_time, week, legend})
);


export interface iState {
    metric: string;
    the_time: string;
    week: number;
    legend: object;
}

export function getState(): iState {
    return store.getState() as iState;
}


export default store;